import { plural, t } from '@lingui/core/macro';
const getToastTitle = (data) => {
    const { type } = data;
    if (type === 'update') {
        return t({
            comment: 'Bulk action: Metadata - Toast title update',
            message: 'Metadata value updated',
        });
    }
    return t({
        comment: 'Bulk action: Metadata - Toast title clear',
        message: 'Metadata value cleared',
    });
};
const getToastMessage = (data) => {
    const { type, status, documentCount, property } = data;
    const propertyName = property.label;
    if (type === 'update') {
        switch (status) {
            case 'success':
                return t({
                    comment: 'Bulk action: Metadata - Toast message update success',
                    message: plural(documentCount, {
                        one: `Successfully updated ${propertyName} for # document`,
                        other: `Successfully updated ${propertyName} for # documents`,
                    }),
                });
            case 'error':
                return t({
                    comment: 'Bulk action: Metadata - Toast message update error',
                    message: plural(documentCount, {
                        one: `Failed to update ${propertyName} for # document`,
                        other: `Failed to update ${propertyName} for # documents`,
                    }),
                });
            default:
                return '';
        }
    }
    switch (status) {
        case 'success':
            return t({
                comment: 'Bulk action: Metadata - Toast message clear success',
                message: plural(documentCount, {
                    one: `Successfully cleared ${propertyName} for # document`,
                    other: `Successfully cleared ${propertyName} for # documents`,
                }),
            });
        case 'error':
            return t({
                comment: 'Bulk action: Metadata - Toast message clear error',
                message: plural(documentCount, {
                    one: `Failed to clear ${propertyName} for # document`,
                    other: `Failed to clear ${propertyName} for # documents`,
                }),
            });
        default:
            return '';
    }
};
export const getToastTexts = (data) => {
    const title = getToastTitle(data);
    const message = getToastMessage(data);
    return { title, message };
};
